// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__1jwkE","quantityInput":"quantityInput__3YZli","buttonMint":"buttonMint__3XZn3","form":"form__1sU9T","heading":"heading__38Qyi"};